<template>
  <div>
    <el-dialog
      :title="DialogTitle"
      :visible.sync="dialogFormVisible"
      @close="handleFormClose"
    >
      <el-form :model="form" ref="ServirequestTypeForm">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="Tipo de Solicitud" label-width="130px">
              <el-input size="mini" v-model="form.Description"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="SLA" label-width="40px">
              <el-select
                size="mini"
                v-model="form.DaysToRespond"
                placeholder="Seleccione un SLA"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.value"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6" v-if="!isEdit">
            <el-form-item label="Estatus" label-width="60px">
              <el-select
                size="mini"
                v-model="form.Estatus"
                placeholder="Seleccione u estatus"
              >
                <el-option
                  v-for="item in optionStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="7">
            <el-form-item label="Dirección" label-width="80px">
              <DirectionSelector
                size="mini"
                :initialDirection="form.Direction"
                @selection-change="handleDirectionChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="Departamento" label-width="110px">
              <DepartmentsComponent
                :initialDirection="form.Direction"
                :initialDeparment="form.Departmet"
                :DirecctionID="form.Direction"
                fieldSize="mini"
                @selectionChange="handleDepartmentChange"
              />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="Empleado" label-width="80px">
              <EmployeeSelector
                :DireccionParams="form.Direction"
                :DeparmentParams="form.Departmet"
                :CurrentEmployee="form.Employee"
                placeholder="Responsable"
                @selection-change="handleEmployeeChange"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="handleFormClose"
          :loading="loading"
          :disabled="loading"
          >Cancelar</el-button
        >
        <el-button
          type="primary"
          @click="SendForm"
          :loading="loading"
          :disabled="loading"
          >Guardar</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import DepartmentsComponent from "@/components/Company/DepartmentsComponent.vue";
// import DirectionSelector from "@/components/Company/DirectionSelector.vue";
// import EmployeeSelector from "@/components/Company/EmployeeSelector.vue";
import DirectionSelector from "@/components/Company/DirectionSelector";
import DepartmentsComponent from "@/components/Company/DepartmentsComponent";
import EmployeeSelector from "@/components/Company/EmployeeSelector";

export default {
  name: "EditServiceRequestTypeForm",
  components: {
    DirectionSelector,
    DepartmentsComponent,
    EmployeeSelector
  },
  props: {
    dialogFormVisible: {
      type: Boolean,
      default: false,
      required: true
    },
    ServiceRequestTypeRow: {
      type: Object,
      default: () => {},
      required: false
    },
    isEdit: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      // dialogFormVisible: false,
      form: {
        Description: "",
        DaysToRespond: "",
        Direction: "",
        Departmet: "",
        Employee: "",
        Estatus: ""
        // delivery: false,
        // type: [],
        // resource: "",
        // desc: "",
      },
      // options: [],
      formLabelWidth: "120px",
      loading: false,
      optionStatus: [
        {
          value: true,
          label: "Activo"
        },
        {
          value: false,
          label: "Inactivo"
        }
      ]
    };
  },
  computed: {
    DialogTitle() {
      if (this.isEdit) {
        return "Editar Tipo de Solicitud";
      } else {
        return "Agregar Tipo de Solicitud";
      }
    },
    options() {
      let options = [];

      for (let i = 1; i < 10; i++) {
        options.push({ value: i, label: `Option ${i}` });
      }
      return options;
    }
  },
  methods: {
    handleFormClose() {
      this.$emit("closeDialog", false);
    },
    handleDirectionChange(value) {
      this.form.Direction = value;
    },
    handleDepartmentChange(value) {
      this.form.Departmet = value;
    },
    handleEmployeeChange(value) {
      this.form.Employee = value;
    },
    async SendForm() {
      if (this.isEdit) {
        await this.PutTypeRequest(this.form);
      } else {
        await this.PostTypeRequest(this.form);
      }
    },
    async PostTypeRequest(form) {
      this.loading = true;
      const payload = {
        Description: form.Description,
        DirectionId: form.Direction,
        responsableId: form.Employee,
        DeparmentId: form.Departmet,
        DaysToRespond: form.DaysToRespond
      };
      await this.$http
        .post("/api/serviceRequestTypes/PostServiceRequestTypeWithSLA", payload)
        .then(() => {
          this.resetServiceRequestTypeForm();
          this.UpdateServiceRequesTypeTable();
          this.handleFormClose();
          // this.data = res.data
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async PutTypeRequest(form) {
      this.loading = true;
      const payload = {
        Id: this.ServiceRequestTypeRow.Id,
        Description: form.Description,
        DirectionId: form.Direction,
        responsableId: form.Employee,
        DeparmentId: form.Departmet,
        DaysToRespond: form.DaysToRespond,
        IsEnabled: form.Estatus
      };
      await this.$http
        .put("/api/serviceRequestTypes/PutServiceRequestTypeWithSLA", payload)
        .then(() => {
          this.resetServiceRequestTypeForm();
          this.UpdateServiceRequesTypeTable();
          this.handleFormClose();
          // this.data = res.data
        })
        .catch((err) => {
          this.$alert(err.message, err.name, {
            type: "error"
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    resetServiceRequestTypeForm() {
      this.$refs["ServirequestTypeForm"].resetFields();

      this.form = {
        Description: "",
        DaysToRespond: "",
        Direction: "",
        Departmet: "",
        Employee: "",
        Estatus: ""
        // delivery: false,
        // type: [],
        // resource: "",
        // desc: "",
      };
    },
    UpdateServiceRequesTypeTable() {
      this.$emit("update-table");
    }
  },
  watch: {
    ServiceRequestTypeRow(Row) {
      this.form.Description = Row.Description;
      this.form.Direction = Row.DirectionId;
      this.form.Departmet = Row.DeparmentId;
      this.form.Employee = Row.responsableId;
      this.form.DaysToRespond = Row.DaysToRespond;
      this.form.Estatus = Row.IsEnabled;
    }
  }
};
</script>

<style lang="scss" scoped></style>
